import * as React from 'react'
import SiteConfig from '../../model/SiteConfig'
import { Tabs, Tab, Navbar } from 'react-bootstrap'
import { RouteComponentProps } from 'react-router'
import { Downtimes } from '../Downtimes/Downtimes'
import { SiteConfigComponent } from './SiteConfig'
import {
  getDowntimes,
  updateDowntime,
  getPenalisingStatus,
  getAlarmGroups,
  revertDowntime,
  splitDowntime,
  copyDowntime,
  getDowntimeEditStatus,
  updateDowntimeEditStatus,
  createDowntime,
  checkDowntimeValidation,
  canEditTimeOff,
  recalculate,
  getSiteAvailability,
  getGeneratorAvailability
} from '../../rest-api/Downtime-api'
import { createSolarGisSite } from '../../rest-api/SiteConfig-api'
import { SiteSelector } from '../SiteConfigList/SiteSelector'
import { FaBolt } from 'react-icons/fa'
import { SiteStoredSettings } from '../../common/LocalStorage'
import { IMessageService } from '../../common/IMessageService'

type Modes = 'downtime' | 'configuration'

export interface DispatchProps {
  siteConfigSave: (siteConfig: SiteConfig) => void
}

export interface StateProps {
  mode: Modes
  siteConfig?: SiteConfig
  siteConfigs: SiteConfig[]
  anySitesLoading: boolean
  allSitesLoading: boolean
  messageService: IMessageService
}

type Props = StateProps & RouteComponentProps & DispatchProps

export class SiteMaster extends React.Component<Props, {}> {
  componentDidUpdate(previousProps: Readonly<Props>): void {
    if (
      this.props.siteConfig &&
      (!previousProps.siteConfig || this.props.siteConfig.key !== previousProps.siteConfig.key)
    ) {
      SiteStoredSettings.SetSelectedSite(this.props.siteConfig.key)
    }
    if (this.props.mode !== SiteStoredSettings.GetSiteMode()) {
      SiteStoredSettings.SetSiteMode(this.props.mode)
    }
  }

  changeSite = (siteConfig: SiteConfig) => {
    this.props.history.push(`/site/${this.props.mode}/${siteConfig.key}`)
  }

  changeMode = (mode: string) => {
    if (this.props.siteConfig && (mode === 'downtime' || mode === 'configuration')) {
      this.props.history.push(`/site/${mode}/${this.props.siteConfig.key}`)
    }
  }

  render() {
    const { siteConfig, mode } = this.props

    return (
      <div id="siteMaster" className="grow parent">
        <Navbar variant="dark" bg="dark" className="fixed">
          <Navbar.Text className="big-text">
            {this.props.allSitesLoading && <FaBolt />}
            {this.props.allSitesLoading
              ? ' Loading sites...'
              : siteConfig
              ? siteConfig.name
              : 'Please choose a site'}
          </Navbar.Text>
          {!this.props.allSitesLoading && (
            <SiteSelector changeSite={this.changeSite} siteConfigList={this.props.siteConfigs} sitesLoading={this.props.anySitesLoading} />
          )}
        </Navbar>
        {siteConfig && (
          <Tabs
            defaultActiveKey="downtime"
            id="uncontrolled-tab-example"
            className="content"
            activeKey={mode}
            onSelect={this.changeMode}
          >
            <Tab eventKey="configuration" title="Site Config" className="tab-content">
              <SiteConfigComponent
                siteConfig={siteConfig}
                save={this.props.siteConfigSave}
                registerSolarGis={createSolarGisSite}
              />
            </Tab>
            <Tab eventKey="downtime" title="Downtime" className="tab-content">
              <Downtimes
                getSiteAvailability={(marketKey, apikey, month) =>
                  getSiteAvailability(marketKey, apikey, month)
                }
                getGeneratorAvailability={(marketKey, apikey, month) =>
                  getGeneratorAvailability(marketKey, apikey, month)
                }
                getDowntimeEditStatus={(marketKey, apikey, month) =>
                  getDowntimeEditStatus(marketKey, apikey, month)
                }
                updateDowntimeEditStatus={(marketKey, apikey, month, status) =>
                  updateDowntimeEditStatus(marketKey, apikey, month, status)
                }
                getDowntimes={(marketKey, apikey, from, to, scadaObjectKey, scadaObjectType) =>
                  getDowntimes(marketKey, apikey, from, to, scadaObjectKey, scadaObjectType)
                }
                updateDowntime={(marketKey, downtime) => updateDowntime(marketKey, downtime)}
                revertDowntime={(marketKey, downtime) => revertDowntime(marketKey, downtime)}
                splitDowntime={(marketKey, downtime, splitTime) =>
                  splitDowntime(marketKey, downtime, splitTime)
                }
                copyDowntime={(marketKey, source, targets) =>
                  copyDowntime(marketKey, source, targets)
                }
                canEditTimeOff={(marketKey, scadaObjectKey, timeOn) =>
                  canEditTimeOff(marketKey, scadaObjectKey, timeOn)
                }
                checkDowntimeValidation={(marketKey, downtime) =>
                  checkDowntimeValidation(marketKey, downtime)
                }
                createDowntime={(marketKey, downtime) => createDowntime(marketKey, downtime)}
                getPenalisingStatus={(marketKey: string) => getPenalisingStatus(marketKey)}
                getAlarmGroups={(marketKey: string) => getAlarmGroups(marketKey)}
                site={siteConfig}
                sendMessage={message => this.props.messageService.sendMessage(message)}
                recalculate={(marketKey, apikey, month) => recalculate(marketKey, apikey, month)}
              />
            </Tab>
          </Tabs>
        )}
      </div>
    )
  }
}
